import * as actions from './actions'

export const defaultState = {
  assessmentGroups: [],
  canvasUrl: '',
  canvasToken: '',
  canvasTokenVerified: false,
  canvasAssignments: [],
  canvasCoursenum: '',
  canvasExternalTools: {},
  coursenum: '',
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case actions.SET_ASSESSMENT_GROUPS:
      return {
        ...state,
        assessmentGroups: action.assessmentGroups,
      }
    case actions.SET_CANVAS_URL:
      return {
        ...state,
        canvasUrl: action.canvasUrl,
      }
    case actions.SET_CANVAS_TOKEN:
      return {
        ...state,
        canvasToken: action.canvasToken,
      }
    case actions.SET_CANVAS_TOKEN_VERIFIED:
      return {
        ...state,
        canvasTokenVerified: action.canvasTokenVerified,
      }
    case actions.SET_CANVAS_COURSENUM:
      return {
        ...state,
        canvasCoursenum: action.canvasCoursenum,
      }
    case actions.SET_CANVAS_ASSIGNMENTS:
      return {
        ...state,
        canvasAssignments: action.canvasAssignments,
      }
    case actions.SET_CANVAS_EXTERNAL_TOOLS:
      return {
        ...state,
        canvasExternalTools: action.canvasExternalTools,
      }
    default:
      return state
  }
}
